var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "sidebar-loading" },
            [_c("w-progress-circular", { attrs: { small: "" } })],
            1
          )
        : _c("app-sidebar-key-value-list", { attrs: { rows: _vm.rows } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }